import {useDispatch, useSelector} from "react-redux";
import useQuery from "./useQuery";
import {elementAuth} from "Store/auth/thunks";

function useAuth() {

  const dispatch = useDispatch()

  const query = useQuery()

  let token = query.get('token')

  const {
    currentRouteKey,
    secure,
  } = useSelector((state) => state.auth);

  const authed = () => {
    const currElement = currentRouteKey.includes('elements') ?
      currentRouteKey.split('.')[1] : '';
    if (token && token !== '' && currElement && currElement !== '') {
      dispatch(elementAuth({
        element: currElement,
        token: token
      }))

    }
  }

  return {
    secure,
    authed
  }
}

export default useAuth
